import { formatRatingGrade } from "@/utils/format.js";
import "./product-catalog-rating-badge.css";

export default function ProductCatalogRatingBadge({ averageGrade }) {
    if (averageGrade == null) {
        return null;
    }

    const label = formatRatingGrade(averageGrade);

    return (
        <span className="product-catalog-rating" aria-label={`Note moyenne : ${label} sur 5`}>
            <span className="product-catalog-rating__star" aria-hidden="true">★</span>
            <span className="product-catalog-rating__value">{label}</span>
        </span>
    );
}
